import type { ReactNode } from "react";
import Icon from "../Icon/Icon";
import "./NotificationCard.css";

export interface NotificationCardProps {
  title: ReactNode;
  meta?: ReactNode;
  avatar?: ReactNode;
  unread?: boolean;
  onClick?: () => void;
  className?: string;
}

/** Compact notification row with an optional avatar, metadata and unread state. */
const NotificationCard = ({
  title,
  meta,
  avatar,
  unread = false,
  onClick,
  className = "",
}: NotificationCardProps) => (
  <button
    type="button"
    className={`ds-notification-card ${unread ? "is-unread" : ""} ${className}`.trim()}
    onClick={onClick}
  >
    {avatar && (
      <span className="ds-notification-card__avatar" aria-hidden="true">
        {avatar}
      </span>
    )}
    <span className="ds-notification-card__body">
      <span className="ds-notification-card__title">{title}</span>
      {meta && <span className="ds-notification-card__meta">{meta}</span>}
    </span>
    {unread && <span className="ds-notification-card__dot" />}
    <Icon
      name="chevronRight"
      size={18}
      className="ds-notification-card__arrow"
    />
  </button>
);

export default NotificationCard;
